module.exports = __webpack_public_path__ + "img/accounting.1d0e0886.svg";